import config from '../../config.json';
import configStatic from '../../config-static.json';
import { withIronSession } from "next-iron-session";
import Container from "../../components/container";
import fetch from "isomorphic-fetch";
import Account from "../../components/account";
import Whatsapp from "../../components/whatsapp";
import {GrClose} from "react-icons/gr";
import Modal from "react-modal";
import {useState} from "react";
import {useForm} from "react-hook-form";
import classNames from "classnames";
import {FiArrowRight} from "react-icons/fi";
import axios from "axios";
import {useToasts} from "react-toast-notifications";

const Cuenta = ({user, menu, history, userDetail})=>{
    const { addToast } = useToasts();
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = useForm();
    const handleSubmitInvoice = async()=>{
        axios({
            url: `/api/invoice`,
            headers: config.api.headers,
            method: 'post',
            data: {
                id: showModal,
                rfc: event.target.rfc.value,
                razon: event.target.razon.value,
                estado: event.target.estado.value,
                codigo_postal: event.target.zipcode.value,
                municipio: event.target.municipio.value,
                colonia: event.target.colonia.value,
                calle: event.target.calle.value,
                exterior: event.target.exterior.value,
                uso: event.target.uso.value
            }
        })
            .then(d=>{
                addToast( d.data.message, { appearance: 'success', autoDismiss: false });
            })
            .catch(e=>{
                const msg = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Ha ocurrido un error, envianmos esta información por email para enviar tu factura';
                addToast( msg, { appearance: 'warning', autoDismiss: false });
            })
    }
    const [showModal, setShowModal]= useState(null);
    return <>
            <Container title="Mi cuenta - Administración" menu={menu} noNewsletter={true}>
              <Account user={user} history={history} userDetail={userDetail} setShowModal={setShowModal}/>
            </Container>
            <Whatsapp/>
        <Modal
            isOpen={!!(showModal)}
            className="dycModal"
            overlayClassName="dycModalOverlay"
            ariaHideApp={false}
        >
            <div className="dycModalHeader">
                <h1 className="dycModalTitle">Completa la información</h1>
                <span className="dycModalClose" onClick={()=>{ setShowModal(null) }}>
                <GrClose/>
            </span>
            </div>
            <div className="dycModalBody">
                <section className="dycComplementModal">
                    <h3 className="marginBottom">Te recordamos que solo puedes solicitar tu factura hasta <u>30 dias despues de tu compra</u>, si tienes alguna duda por favor ponte en contacto con nosotros.</h3>
                    <form onSubmit={handleSubmit(handleSubmitInvoice)}>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.rfc?.message})}>
                            <div>
                                <label>RFC</label>
                                <input type="text"
                                       defaultValue=""
                                       {...register('rfc', {
                                           required: { value: true, message: 'Escribe tu RFC' }
                                       })}
                                />
                            </div>
                            <span className="inputError">{errors?.rfc?.message}</span>
                        </div>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.razon?.message})}>
                            <div>
                                <label>Razón social (como aparece en tu constancia de situacion fiscal)</label>
                                <input type="text"
                                       defaultValue=""
                                       {...register('razon', {
                                           required: { value: true, message: 'Escribe tu razón social' }
                                       })}
                                />
                            </div>
                            <span className="inputError">{errors?.razon?.message}</span>
                        </div>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.uso?.message})}>
                            <div>
                                <label>Uso</label>
                                <select
                                    defaultValue={""}
                                    {...register('uso', {
                                        required: { value: true, message: 'Selecciona una opción' }
                                    })}>
                                    <option value="">Selecciona una opción</option>
                                    <option value="Por definir">Por definir</option>
                                    <option value="Gastos en general">Gastos en general</option>
                                </select>
                            </div>
                            <span className="inputError">{errors?.uso?.message}</span>
                        </div>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.estado?.message})}>
                            <div>
                                <label>Estado</label>
                                <select
                                    defaultValue={""}
                                    {...register('estado', {
                                        required: { value: true, message: 'Selecciona una opción' }
                                    })}>
                                    <option value="">Selecciona un estado</option>
                                    { configStatic.states.map(i=> {return <option value={i.name}>{i.name}</option>})  }
                                </select>
                            </div>
                            <span className="inputError">{errors?.estado?.message}</span>
                        </div>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.municipio?.message})}>
                            <div>
                                <label>Alcaldia o municipio</label>
                                <input type="text"
                                       defaultValue=""
                                       {...register('municipio', {
                                           required: { value: true, message: 'Escribe alcaldia o municipio' }
                                       })}
                                />
                            </div>
                            <span className="inputError">{errors?.municipio?.message}</span>
                        </div>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.zipcode?.message})}>
                            <div>
                                <label>Codigo postal</label>
                                <input type="text"
                                       defaultValue=""
                                       {...register('zipcode', {
                                           required: { value: true, message: 'Escribe tu codigo postal' }
                                       })}
                                />
                            </div>
                            <span className="inputError">{errors?.colonia?.message}</span>
                        </div>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.colonia?.message})}>
                            <div>
                                <label>Colonia</label>
                                <input type="text"
                                       defaultValue=""
                                       {...register('colonia', {
                                           required: { value: true, message: 'Escribe tu colonia' }
                                       })}
                                />
                            </div>
                            <span className="inputError">{errors?.colonia?.message}</span>
                        </div>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.calle?.message})}>
                            <div>
                                <label>Calle</label>
                                <input type="text"
                                       defaultValue=""
                                       {...register('calle', {
                                           required: { value: true, message: 'Escribe tu RFC' }
                                       })}
                                />
                            </div>
                            <span className="inputError">{errors?.calle?.message}</span>
                        </div>
                        <div className={classNames('inputItem', { 'inputItem-error' :  errors?.exterior?.message})}>
                            <div>
                                <label>Número exterior e interior</label>
                                <input type="text"
                                       defaultValue=""
                                       {...register('exterior', {
                                           required: { value: true, message: 'Escribe tu numero exterior e interior' }
                                       })}
                                />
                            </div>
                            <span className="inputError">{errors?.exterior?.message}</span>
                        </div>
                        {(isSubmitting)
                            ?  <div className="flex-center"><div className="progress"><span className="progress-bar"/></div></div>
                            : <button className="button" disabled={!!(isSubmitSuccessful)}>Solicitar mi factura <FiArrowRight/></button>}
                    </form>
                </section>
            </div>
        </Modal>
        </>
};

export const getServerSideProps = withIronSession(
    async ({ req, res }) => {
        const user = req.session.get("user");
        const resMenu = await fetch(`${config.api.uri}/v1/cat/menu/1?apikey=${config.api.apikey}`);
        const resJSONMenu = await resMenu.json();
        if (user && user.id_usuario) {
            const history = await fetch(`${config.api.uri}/v1/buy/user/${user.id_usuario}?apikey=${config.api.apikey}`);
            const resHistory = await history.json();
            const userDetail = await fetch(`${config.api.uri}/v1/user/${user.id_usuario}?apikey=${config.api.apikey}`);
            const resuserDetail = await userDetail.json();
            return {
                props: {
                    user,
                    menu: resJSONMenu,
                    history: resHistory,
                    userDetail: resuserDetail
                }
            };
        }else{
            return{
                redirect:{
                    destination: '/cuenta/login',
                    permanent: false
                }
            }
        }
    },
    {
        password: config.cookie.signature,
        cookieName: config.cookie.name,
        cookieOptions: {
            secure: config.cookie.secure
        }
    }
);


export default  Cuenta;
